import i18n from '../../i18n'

const PAZYMATIPAS = {
  'zemes-ukio': {
    tipas: 'zemes-ukio',
    tooltipPrefix: 'NtrPaslaugos. Pažyma. Žemės ūkio.',

    title: i18n.t('Pažyma apie žemės ūkio paskirties žemę'),
    sarasasTitle: i18n.t('Užsakytos pažymos'),
    turtaiTitle: i18n.t(
      'NTR duomenys apie asmens turimą žemės ūkio paskirties žemę'
    ),
    turtaiWarning: i18n.t('Jūs neturite žemės ūkio paskirties žemės'),
    turtaiIgaliojimasWarning: i18n.t(
      'Jūsų įgaliotojas neturi žemės ūkio paskirties žemės'
    ),

    uzsakytiConfirmTitle: i18n.t('Pažymos užsakymas'),
    uzsakytiConfirmText: i18n.t('Ar tikrai norite užsakyti pažymą?'),
    uzsakytiConfirmTikrinti: i18n.t(
      'Pažyma apie žemės ūkio paskirties žemę RC savitarnoje bus pateikta, kai įgaliojimo informaciją per skuboje nurodytą laikotarpį patikrins atsakingas darbuotojas.'
    ),
    uzsakytiSarasasBtn: i18n.t('Užsakyti pažymą'),
    uzsakytiBtn: i18n.t('Užsakyti pažymą'),

    deleteText: i18n.t('pažymos užsakymą Nr. '),

    pazymaTitle: i18n.t('Pažyma apie asmens turimą žemės ūkio paskirties žemę'),

    extraTitle: i18n.t('Pažymos užsakymas'),
    extraText: i18n.t('Ar tikrai norite užsakyti pažymą?'),

    routeList: 'pazymosZemesUkio',
    routeEdit: 'pazymaZemesUkio',
  },
  'misku-ukio': {
    tipas: 'misku-ukio',
    tooltipPrefix: 'NtrPaslaugos. Pažyma. Miškų ūkio.',

    title: i18n.t('Pažyma apie miškų ūkio paskirties žemę'),
    sarasasTitle: i18n.t('Užsakytos pažymos'),
    turtaiTitle: i18n.t(
      'NTR duomenys apie asmens turimą miškų ūkio paskirties žemę'
    ),
    turtaiWarning: i18n.t('Jūs neturite miškų ūkio paskirties žemės'),
    turtaiIgaliojimasWarning: i18n.t(
      'Jūsų įgaliotojas neturi miškų ūkio paskirties žemės'
    ),

    uzsakytiConfirmTitle: i18n.t('Pažymos užsakymas'),
    uzsakytiConfirmText: i18n.t('Ar tikrai norite užsakyti pažymą?'),
    uzsakytiConfirmTikrinti: i18n.t(
      'Pažyma apie žemės ūkio paskirties žemę RC savitarnoje bus pateikta, kai įgaliojimo informaciją per skuboje nurodytą laikotarpį patikrins atsakingas darbuotojas.'
    ),
    uzsakytiSarasasBtn: i18n.t('Užsakyti pažymą'),
    uzsakytiBtn: i18n.t('Užsakyti pažymą'),

    deleteText: i18n.t('pažymos užsakymą Nr. '),

    pazymaTitle: i18n.t('Pažyma apie asmens turimą miškų ūkio paskirties žemę'),

    extraTitle: i18n.t('Pažymos užsakymas'),
    extraText: i18n.t('Ar tikrai norite užsakyti pažymą?'),

    routeList: 'pazymosMiskuUkio',
    routeEdit: 'pazymaMiskuUkio',
  },
  'zemes-sklypas': {
    tipas: 'zemes-sklypas',
    tooltipPrefix: 'NtrPaslaugos. Pažyma. Žemės sklypas.',

    title: i18n.t('Žemės sklypo planas'),
    sarasasTitle: i18n.t('Užsakyti žemės sklypai'),
    sklypaiTitle: i18n.t('Asmens žemės sklypai'),
    turtaiTitle: i18n.t('Žemės sklypo plano užsakymas'),
    turtaiWarning: i18n.t(
      'Jūs neturite nei vieno Jums priklausančio žemės sklypo'
    ),
    turtaiIgaliojimasWarning: i18n.t(
      'Jūs neturite nei vieno Jūsų įgaliotojui priklausančio žemės sklypo'
    ),

    uzsakytiConfirmTitle: i18n.t('Žemės sklypo plano užsakymas'),
    uzsakytiConfirmText: i18n.t(
      'Ar tikrai norite užsakyti žemės sklypo planą (-us)?'
    ),
    uzsakytiConfirmTikrinti: i18n.t(
      'Žemės sklypo planas RC savitarnoje bus pateiktas, kai įgaliojimo informaciją per skuboje nurodytą laikotarpį patikrins atsakingas darbuotojas.'
    ),
    uzsakytiSarasasBtn: i18n.t('Užsakyti žemės sklypo planą'),
    uzsakytiBtn: i18n.t('Užsakyti žemės sklypo planą'),

    deleteText: i18n.t('žemės sklypo plano užsakymą Nr. '),

    pazymaTitle: i18n.t('Žemės sklypo planas'),
    turtasUzsakomasTitle: i18n.t('Asmens žemės sklypai'),

    extraTitle: i18n.t('Žemės sklypo plano užsakymas'),
    extraText: i18n.t('Ar tikrai norite užsakyti žemės sklypą?'),

    routeList: 'pazymosZemesSklypas',
    routeNew: 'pazymaSklypasTurtas',
    routeEdit: 'pazymaZemesSklypas',
  },
}

const PAZYMABUSENA = {
  rengiamas: {
    key: 'rengiamas',
    title: i18n.t('Rengiamas'),
  },
  laukia_apmokejimo: {
    key: 'laukia_apmokejimo',
    title: i18n.t('Laukia apmokėjimo'),
  },
  apmoketas: {
    key: 'apmoketas',
    title: i18n.t('Apmokėtas'),
  },
  laukia_patvirtinimo: {
    key: 'laukia_patvirtinimo',
    title: i18n.t('Laukia patvirtinimo'),
  },
  tvirtinamas: {
    key: 'tvirtinamas',
    title: i18n.t('Tvirtinamas'),
  },
  patvirtintas: {
    key: 'patvirtintas',
    title: i18n.t('Patvirtintas'),
  },
  atmestas: {
    key: 'atmestas',
    title: i18n.t('Atmestas'),
  },
  vykdomas: {
    key: 'vykdomas',
    title: i18n.t('Vykdomas'),
  },
  ivykdytas: {
    key: 'ivykdytas',
    title: i18n.t('Įvykdytas'),
  },
  neivykdytas: {
    key: 'neivykdytas',
    title: i18n.t('Neįvykdytas'),
  },
  nutrauktas: {
    key: 'nutrauktas',
    title: i18n.t('Nutrauktas'),
  },
}

export default {
  mixins: { i18n },
  pazymaTipas: PAZYMATIPAS,
  pazymaBusena: PAZYMABUSENA,
  getPazymaTipas(payload) {
    return PAZYMATIPAS[payload] ? PAZYMATIPAS[payload] : { tipas: payload }
  },
  getPazymaBusena(payload) {
    return PAZYMABUSENA[payload]
      ? PAZYMABUSENA[payload]
      : { key: payload, title: payload }
  },
}
